import React, { useState, useEffect } from "react";
import styles from "./index.module.css";
import ReportTableQualifyingGroup from "Reporting/Components/ReportTableQualifyingGroup";
import { useActiveTicketsQualifingGroup } from "./useActiveTicketsQualifingGroup";
import Loader from "shared/Loader";

/*
 * Table displaying different items in a report using Diamond integration
 */
export default function ReportTableListQualifyingGroup({
  filters,
  setReportsLength,
  setReportData,
  fetchTrigger,
}) {
  const [reports, setReports] = useState([]);
  const [allSortedReports, setAllSortedReports] = useState([]);

  const { data, isLoading, isError, refetch } = useActiveTicketsQualifingGroup({
    type: filters.type,
    year: filters.year,
    groups: filters.groups,
    events: filters.events,
  });
  useEffect(() => {
    if (typeof fetchTrigger !== "undefined") {
      refetch?.();
    }
  }, [fetchTrigger]);

  useEffect(() => {
    if (data) {
      const groupedReports = data.map((group) => ({
        groupName: group.groupName,
        reports: group.rows || [],
      }));

      setReports(groupedReports);
      setReportsLength?.(groupedReports.length || 0);

      const flatData = groupedReports.flatMap((grp) =>
        grp.reports.map((r) => ({ ...r, groupName: grp.groupName }))
      );
      setReportData(flatData);

      setAllSortedReports([]);
    }
  }, [data]);

  // Update parent with sorted/filtered data whenever it changes
  useEffect(() => {
    if (allSortedReports.length > 0) {
      setReportData(allSortedReports);
    }
  }, [allSortedReports]);

  const handleSortedReportsUpdate = (groupName, sortedData) => {
    setAllSortedReports((prev) => {
      const filtered = prev.filter((item) => item.groupName !== groupName);

      const withGroupName = sortedData.map((item) => ({ ...item, groupName }));

      const next = [...filtered, ...withGroupName];

      const isEqual =
        prev.length === next.length &&
        prev.every(
          (p, i) =>
            p.groupName === next[i].groupName &&
            JSON.stringify(p) === JSON.stringify(next[i])
        );

      return isEqual ? prev : next;
    });
  };
  if (isError) {
    return <div>Something went wrong...</div>;
  }
  if (isLoading) {
    return <Loader />;
  }
  if (reports.length === 0) {
    return <div>No Reports Found</div>;
  }

  return (
    <div className={styles.container}>
      {reports.map((report, index) => (
        <React.Fragment key={index}>
          <ReportTableQualifyingGroup
            reports={report.reports}
            filters={filters}
            groupName={report.groupName}
            onSortedReportsChange={handleSortedReportsUpdate}
          />
        </React.Fragment>
      ))}
    </div>
  );
}
